import { Space } from 'antd';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import CustomTable from '../../components/CustomTable/CustomTable';
import Title from '../../components/Title';
import {
    allPackages,
    deletePackage,
    getPackages,
    packagesLoadingStatus,
} from '../../redux/slices/insuranceSlice';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomModal from '../../components/CustomModal';

const optionsSortBy = [
    {
        label: 'Name - A-Z',
        id: 'A-Z',
        value: 'A-Z',
    },
    {
        label: 'Name - Z-A',
        id: 'Z-A',
        value: 'Z-A',
    },
];

export default function InsurancePage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const packages = useSelector(allPackages);
    const packagesStatus = useSelector(packagesLoadingStatus);

    const [isDeletePackageModalVisible, setIsDeletePackageModalVisible] =
        useState(false);
    const [packageData, setPackageData] = useState({});
    const [errors, setErrors] = useState({});
    const modifiedPackagesForTable = packages?.map((el) => {
        return {
            ...el,
            clients: el.clients.join(', '),
            service_provider:
                el.service_provider === 'mysafety' || !el.is_integration
                    ? 'NI'
                    : el.service_provider,
        };
    });

    useEffect(() => {
        dispatch(getPackages());
    }, [dispatch]);

    const onCreatePackageClick = () => {
        navigate('package/create');
    };

    const onEditPackage = (record, e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        navigate(`package/${record.id}/edit`);
    };

    const toggleDeletePackageModal = (record, e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!record) {
            setIsDeletePackageModalVisible(!isDeletePackageModalVisible);
            setErrors({});
        } else {
            setPackageData({ name: record.name, id: record.id });
            setIsDeletePackageModalVisible(!isDeletePackageModalVisible);
            setErrors({});
        }
    };

    const onDeletePackage = async () => {
        try {
            await dispatch(deletePackage(packageData.id)).unwrap();
            toast.success('Package deleted successfully');
            toggleDeletePackageModal();
            dispatch(getPackages());
        } catch (error) {
            toast.error(error.errors);
            setErrors(error.errors);
        }
    };

    const actionsOption = {
        title: 'Actions',
        render: (_, record) => (
            <Space size="middle">
                <EditOutlined onClick={(e) => onEditPackage(record, e)} />
                <DeleteOutlined
                    onClick={(e) => toggleDeletePackageModal(record, e)}
                />
            </Space>
        ),
    };

    const getFilteredPackages = (data, filter, sortBy) => {
        const filteredData = data.filter((el) =>
            el?.name.toLowerCase().includes(filter.toLowerCase()),
        );

        if (sortBy === 'A-Z' || sortBy === 'Z-A') {
            const order = sortBy === 'A-Z' ? 1 : -1;
            return filteredData.sort(
                (a, b) => a?.name.localeCompare(b?.name) * order,
            );
        }

        return filteredData;
    };

    return (
        <div>
            <Helmet>
                <title>Console Defentry - Insurance</title>
            </Helmet>
            <Title>Insurance</Title>
            <div className="table-wrapper">
                <CustomTable
                    tableHeader={[
                        'ID',
                        'Package name',
                        'Contract ID',
                        'Package type',
                        'Clients',
                        'Provider',
                        'Actions',
                    ]}
                    columnsDataMap={{
                        'Package name': 'name',
                        'Package type': 'type',
                        Provider: 'service_provider',
                    }}
                    functionalCell={{ Actions: actionsOption }}
                    onAddButtonClick={onCreatePackageClick}
                    tablePannelTitle="Table of packages"
                    searchInputPlaceholder="Search by name"
                    topPannelButtonText="Add package"
                    data={modifiedPackagesForTable}
                    getFilteredData={getFilteredPackages}
                    isLoading={packagesStatus === 'loading'}
                    withFilter
                    withSortBy
                    options={optionsSortBy}
                />
            </div>
            <CustomModal
                title={
                    <p>
                        Are you sure you want to delete
                        <span className="highlighted-text">{` ${packageData.name} `}</span>
                        client?
                    </p>
                }
                subText="You will delete this package without recovery"
                subTextAlign="center"
                isModalVisible={isDeletePackageModalVisible}
                onAcceptButtonClick={onDeletePackage}
                onCancelButtonClick={toggleDeletePackageModal}
                cancelButtonText="Cancel"
                acceptButtonText="Delete"
            >
                {errors.package && (
                    <p className="modal__error-text">{errors.package}</p>
                )}
            </CustomModal>
        </div>
    );
}
